exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-news[data-v-2df6d96c] .el-carousel .el-carousel__container{height:100%}.image-news[data-v-2df6d96c] .el-carousel .el-carousel__arrow{width:30px;height:40px;border-radius:unset;background-color:rgba(0,0,0,.3)}.image-news[data-v-2df6d96c] .el-carousel .el-carousel__arrow:hover{background-color:rgba(0,0,0,.4)}.image-news[data-v-2df6d96c] .el-carousel .el-carousel__arrow--left{left:0}.image-news[data-v-2df6d96c] .el-carousel .el-carousel__arrow--right{right:0}", ""]);

// exports
